// extracted by mini-css-extract-plugin
export var logo = "_7d-2";
export var logoWrapper = "_7d-1";
export var strip = "_7d-0";